export default "__VITE_ASSET__UDGBSHem__"